import { OmpColumnsLayout, OmpMoment, OmpPageSectionItem, OmpSectionKey } from '../../../_models';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  OmpColumnChildKeys,
  OmpColumnCountOptions,
  OmpColumnsChildField,
  OmpColumnsLayoutOptions,
  OmpColumnsVerticalAlignOptions,
  OmpSectionCatalog,
  isOmpColumnChildKey,
} from '../../order-management-portal.sections';
import { newOmpColumnChild, OmpSectionSettings } from '..';

// The only section that holds other sections. Editing a column's own settings is handed back to
// the sidebar, which opens the child in the same panel (see openChildSettings).
@Component({
  selector: 'omp-columns-settings',
  templateUrl: './columns-settings.component.html',
  styleUrls: ['../controls/omp-controls.scss'],
})
export class OmpColumnsSettingsComponent extends OmpSectionSettings {
  public countOptions = OmpColumnCountOptions;
  public layoutOptions = OmpColumnsLayoutOptions;
  public verticalAlignOptions = OmpColumnsVerticalAlignOptions;
  public childOptions = OmpColumnChildKeys.map((key) => ({
    value: key,
    label: OmpSectionCatalog[key] ? OmpSectionCatalog[key].name : key,
  }));

  @Input() brandVariables: any = {};
  @Input() page = '';
  @Input() moment: OmpMoment = OmpMoment.None;

  @Output() openChild = new EventEmitter<OmpPageSectionItem>();

  get columns(): OmpPageSectionItem[] {
    let list: OmpPageSectionItem[] = [];
    if (this.data && Array.isArray(this.data[OmpColumnsChildField])) {
      list = this.data[OmpColumnsChildField];
    }
    return list;
  }

  get showLayout(): boolean {
    return Number(this.data ? this.data.column_count : 0) === 2;
  }

  childName(child: OmpPageSectionItem): string {
    const def = OmpSectionCatalog[child.key];
    return def ? def.name : child.key;
  }

  onCountChange() {
    const count = Number(this.data.column_count);
    const list = this.columns;
    while (list.length < count) {
      list.push(this.newChild(OmpSectionKey.TextAndImage));
    }
    while (list.length > count) {
      list.pop();
    }
    this.data[OmpColumnsChildField] = list;
    if (count !== 2) {
      this.data.layout = OmpColumnsLayout.Equal;
    }
    this.change.emit();
  }

  onChildKeyChange(index: number, key: string) {
    const list = this.columns;
    if (isOmpColumnChildKey(key) && index >= 0 && index < list.length) {
      list[index] = this.newChild(key);
      this.change.emit();
    }
  }

  editChild(child: OmpPageSectionItem) {
    this.openChild.emit(child);
  }

  private newChild(key: string): OmpPageSectionItem {
    return newOmpColumnChild(key, this.page, this.moment, this.brandVariables);
  }
}
